import Ethics from './Ethics';
export default Ethics;